/**
 * Updates the selected option description for standard product selectors.
 */
(function () {
  "use strict";
  if (window.KessSelectorDescriptionInitialized) return;
  window.KessSelectorDescriptionInitialized = true;

  function updateDescription(control) {
    const selection =
      control instanceof HTMLSelectElement
        ? control.selectedOptions[0]
        : control instanceof HTMLInputElement
          ? control
          : null;
    if (!selection?.hasAttribute("data-kess-selector-description")) return;

    const selector = control.closest("variant-selects");
    const container = selector?.querySelector("[data-kess-selector-description-container]");
    if (!container) return;

    const description = selection.dataset.kessSelectorDescription || "";
    const name = container.querySelector("[data-kess-selector-name]");
    const value = container.querySelector("[data-kess-selector-description]");

    if (name) name.textContent = selection.value || "";
    if (value) value.textContent = description;
    container.hidden = !description.trim();
  }

  document.addEventListener("change", (event) => {
    const control = event.target;
    if (control instanceof HTMLInputElement || control instanceof HTMLSelectElement) {
      updateDescription(control);
    }
  });

  function init(root = document) {
    root
      .querySelectorAll("variant-selects input[data-kess-selector-description]:checked, variant-selects select")
      .forEach(updateDescription);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", () => init());
  else init();
})();
